import {
    Box,
    Provider,
    Icon,
    Container,
    Typography,
    Grid,
    formataDataCompleta,
    Skeleton,
    AvatarMUI,
    // @ts-ignore
  } from "@bsp/styleguide";
  import { useEffect, useState } from "react";
  import styled from "styled-components";
  // @ts-ignore
  import { logout } from "@bsp/auth";
  
  export default function Header() {
    const [possuiUsuario, setPossuiUsuario] = useState(false);
    const [nomeUsuario, setNomeUsuario] = useState("...");
    const [avatar, setAvatar] = useState(null);
    const BoxBorder = styled(Box)`
      border-bottom: thin solid rgb(221, 221, 221);
      margin-bottom: 25px;
    `;
  
    function handleAvatar(nome: string) {
      const objAvatar = {
        style: {
          backgroundColor: "#ff9122",
        },
        variant: "circular",
        size: 40,
        src: avatar,
      };
  
      return objAvatar;
    }
  
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem("user"));
      const userAvatar = localStorage.getItem("userAvatar");
  
      if (user) {
        if (userAvatar) setAvatar(`data:image/png;base64,${userAvatar}`);
  
        setNomeUsuario(user.nome || user.usuario);
        setPossuiUsuario(true);
      }
    }, []);
  
    return (
      <Provider>
        <BoxBorder style={{ position: "relative" }}>
          <Container maxWidth="lg">
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box
                sx={{ pt: 3, pb: 3 }}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Typography variant="subtitle">
                  Bem vindo ao <b>BemSign</b>
                </Typography>
                <Typography
                  variant="subtitle2"
                  style={{ lineHeight: "inherit", marginLeft: "24px" }}
                >
                  {formataDataCompleta(new Date())}
                </Typography>
              </Box>
              <Box display="flex" mr={5}>
                <Box sx={{ mr: 2 }}>
                  {possuiUsuario ? (
                    <AvatarMUI {...handleAvatar(nomeUsuario)} />
                  ) : (
                    <Skeleton type="icon" />
                  )}
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                >
                  {possuiUsuario ? (
                    <Typography variant="subtitle2" component="div"></Typography>
                  ) : (
                    <Skeleton type="text" width={60} />
                  )}
                  {possuiUsuario ? (
                    <Typography variant="subtitle2" component="div">
                      {nomeUsuario}
                    </Typography>
                  ) : (
                    <Skeleton type="text" width={60} />
                  )}
                </Box>
                <Box
                  style={{
                    right: "15px",
                    position: "absolute",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  <Icon
                    color="#424242"
                    name="HomeLogout"
                    onClick={() => logout()}
                    size="20px"
                  />
                </Box>
              </Box>
            </Grid>
          </Container>
        </BoxBorder>
      </Provider>
    );
  }
  